import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from "@material-ui/core"
import { useContext, useState } from "react"
import AppContext from "~/contexts/App"

import { SRT_LANGUAGES } from "~/constants/languages"
import useStyles from "./styles"

const AddLanguageToSrtDialog = () => {
  const classes = useStyles()
  const theme = useTheme()
  const { dialogs, closeDialog } = useContext(AppContext)
  const thisDialog = dialogs?.["addLanguageToSrt"] || {}
  const { open = false, data } = thisDialog
  const captions = thisDialog?.data?.lesson?.captions || []
  const captionId = thisDialog?.data?.caption?.id || null
  const [languageValue, setLanguageValue] = useState(
    thisDialog?.data?.caption?.srt_language || "en",
  )
  const [errorMessage, setErrorMessage] = useState("")

  const handleClose = () => {
    closeDialog("addLanguageToSrt", true)
    setLanguageValue("en")
    setErrorMessage("")
  }

  //Check if language is already added or we are editing the language
  const handleLanguageDisabled = (language) => {
    return captions.map((c) => c.srt_language).includes(language) && !captionId
  }

  const handleSetSrtLanguage = () => {
    if (handleLanguageDisabled(languageValue)) {
      setErrorMessage("This language is already added")
    } else {
      let data = {
        srtLanguage: languageValue,
        acceptedFiles: thisDialog?.data?.acceptedFiles,
        lesson: thisDialog?.data?.lesson,
        uploadedVideo: thisDialog?.data?.uploadedVideo,
        captionId: captionId,
      }
      closeDialog("addLanguageToSrt", true, data)
    }
  }

  const handleChangeLanguage = (language) => {
    setLanguageValue(language)
    setErrorMessage("")
  }

  return (
    <Dialog classes={{ paperWidthSm: classes.dialogContainer }} open={open}>
      <DialogTitle className={classes.dialogTitle}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className={classes.dialogTop}
        >
          <Typography variant="h2" className={classes.title}>
            Add Srt Language
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Typography className="mb-2">
          Choose the language of the .srt file
        </Typography>
        <Box className="flex items-center w-full">
          <FormControl className="w-1/3" variant="outlined">
            <Select
              SelectDisplayProps={{
                style: { paddingTop: 8, paddingBottom: 8 },
              }}
              fullWidth
              className="w-full"
              value={languageValue}
              onChange={(e) => handleChangeLanguage(e.target.value)}
              classes={{ icon: classes.icon }}
            >
              {Object.keys(SRT_LANGUAGES).map((language, index) => {
                const languageDisabled = handleLanguageDisabled(language)
                return (
                  <MenuItem
                    value={language}
                    key={index}
                    disabled={languageDisabled}
                  >
                    <Typography variant="subtitle1">
                      {SRT_LANGUAGES[language]}
                    </Typography>
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        </Box>
        <Typography className={classes.errorMessage}>{errorMessage}</Typography>
      </DialogContent>
      <DialogActions
        style={{
          position: "absolute",
          bottom: 4,
          width: "100%",
        }}
        className={classes.actions}
      >
        <Box
          display="flex"
          justifyContent="flex-end"
          width="100%"
          marginLeft="20px"
          marginRight="20px"
          className={classes.actionBox}
        >
          <Button
            onClick={handleClose}
            style={{ height: "40px", marginRight: "10px" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSetSrtLanguage}
            style={{ height: "40px", marginRight: "10px" }}
          >
            Add
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

AddLanguageToSrtDialog.propTypes = {}

export default AddLanguageToSrtDialog
